import { Msg, MsgProps } from "src/i18n/Msg";
import styles from "src/components/atoms/Button/styles.module.css";
import cx from "classnames";

export enum BUTTONTYPE {
  LIGHT = "light",
}

type Props = {
  text: MsgProps;
  onClick?: () => void;
  disabled?: boolean;
  type?: "submit" | "reset" | "button";
  btnType?: BUTTONTYPE;
  isLoading?: boolean;
  rightIcon?: string;
  leftIcon?: string;
  className?: string;
};

export const Button: React.FC<Props> = ({
  text,
  onClick,
  disabled,
  type = "button",
  btnType,
  rightIcon,
  className,
  leftIcon,
}) => (
  <button
    type={type}
    disabled={disabled}
    onClick={onClick}
    className={cx(styles.btn, className, {
      [styles.lightBtn]: btnType === BUTTONTYPE.LIGHT,
      [styles.disabled]: disabled,
    })}
  >
    {leftIcon && <img src={leftIcon} />}
    <Msg {...text} />
    {rightIcon && <img src={rightIcon} />}
  </button>
);
